import React from "react";

export default function TextButton({ children, className = "", ...props }) {
  return (
    <button
      type="button"
      {...props}
      className={
        `
        bg-transparent border-0 p-0
        text-[#006CE0] cursor-pointer
        hover:underline

        disabled:cursor-not-allowed
        disabled:opacity-50
        disabled:hover:no-underline
        disabled:pointer-events-none
        ` + className
      }
    >
      {children}
    </button>
  );
}